var _excluded = ["disabled", "style", "className", "full"];

var _templateObject, _templateObject2, _templateObject3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { bool, string, shape } from 'prop-types';
import { Visibility, VisibilityOff } from '@gympass/yoga-icons';
import Input from './Input';
var ICON_SIZE = 24;
var StyledInput = styled(Input)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var input = _ref.theme.yoga.components.input;
  return "\n    padding-right: " + (ICON_SIZE + input.padding.right) + "px;\n  ";
});
var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-block;\n\n  ", "\n"])), function (_ref2) {
  var full = _ref2.full;
  return "\n    " + (full ? 'width: 100%;' : '') + "\n  ";
});
var IconWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var disabled = _ref3.disabled,
      _ref3$theme$yoga = _ref3.theme.yoga,
      colors = _ref3$theme$yoga.colors,
      spacing = _ref3$theme$yoga.spacing,
      input = _ref3$theme$yoga.components.input;
  return "\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    padding-right: " + spacing.small + "px;\n    padding-left: " + spacing.xxsmall + "px;\n\n    height: " + input.height + "px;\n    cursor: pointer;\n\n    outline: none;\n\n    &:hover svg, &:focus svg {\n      fill: " + input.font.color.focus + ";\n    }\n\n    " + (disabled ? "\n      cursor: not-allowed;\n      pointer-events: none;\n    " : '') + "\n\n    svg {\n      height: " + input.height + "px;\n      width: 20px;\n      fill: " + input.font.color["default"] + ";\n\n      " + (disabled ? "\n            fill: " + colors.elements.backgroundAndDisabled + ";\n            pointer-events: none;" : '') + "\n    }\n  ";
});

var Password = function Password(_ref4) {
  var disabled = _ref4.disabled,
      style = _ref4.style,
      className = _ref4.className,
      full = _ref4.full,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded);

  var _useState = useState(false),
      showPassword = _useState[0],
      toggleShowPassword = _useState[1];

  var inputRef = useRef(null);
  useEffect(function () {
    var element = inputRef.current;

    if (element.value.length) {
      element.setSelectionRange(element.value.length, element.value.length);
    }
  }, [showPassword]);

  var togglePassword = function togglePassword(e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleShowPassword(!showPassword);
    }

    if (e.type === 'click') {
      inputRef.current.focus();
    }
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    style: style,
    className: className,
    full: full
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    disabled: disabled,
    full: full,
    ref: inputRef,
    cleanable: false,
    type: showPassword ? 'text' : 'password'
  })), /*#__PURE__*/React.createElement(IconWrapper, {
    tabIndex: disabled ? null : 0,
    onClick: togglePassword,
    onKeyDown: togglePassword,
    disabled: disabled,
    role: "button"
  }, showPassword ? /*#__PURE__*/React.createElement(Visibility, {
    width: 20,
    height: 20
  }) : /*#__PURE__*/React.createElement(VisibilityOff, {
    width: 20,
    height: 20
  })));
};

Password.propTypes = {
  className: string,
  disabled: bool,
  full: bool,
  style: shape({})
};
Password.defaultProps = {
  className: undefined,
  disabled: false,
  full: false,
  style: undefined
};
export default Password;